import React, { useState, useEffect } from "react";
import TextCard from "../components/TextCard";
import PublicHeader from "../components/PublicHeader";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/ProjectPage.css";
import SiteMenu from "../components/SiteMenu";
import { useAuth } from "../context/AuthContext";
import { OffreService } from "../services/OffreService";
import { AO } from "../types/AO";

const OffrePage: React.FC = () => {
  const navigate = useNavigate();
  const { api } = useAuth();

  const [publishedAO, setPublishedAO] = useState<AO[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchPublishedAO = async () => {
      try {
        const data = await OffreService.getAllPublishedAO(api);
        setPublishedAO(data);
      } catch (error) {
        console.error("Erreur récupération AO publiés :", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPublishedAO();
  }, [api]);

  const activities = [
    { label: "Appel d'offre", path: "offre" },
    { label: "Projet", path: "/project" },
    { label: "Calendrier", path: "/calendar" },
    { label: "Événements", path: "/event" }
  ];

  // Filtrer les AO selon le searchTerm
  const filteredAO = publishedAO.filter(
    (item) =>
      item.titre.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item.reference && item.reference.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  return (
    <div className="project-page-wrapper">
      <div className="map-page-header mb-3">
        <PublicHeader />
      </div>

      <div className="container-fluid">
        <div className="row">
          {/* Menu */}
          <div className="col-12 col-md-3 col-lg-2 mb-3 mb-md-0">
            <SiteMenu activities={activities} />
          </div>

          {/* Contenu principal */}
          <main className="col-12 col-md-9 col-lg-10 project-page">
            <h2>Les appels d'offres publiés</h2>

            {/* Barre de recherche */}
            <div className="mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Rechercher un appel d'offre par titre ou référence..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {loading ? (
              <p>Chargement...</p>
            ) : filteredAO.length === 0 ? (
              <p>Aucun appel d'offre correspondant.</p>
            ) : (
              <div className="row">
                {filteredAO.map((item, index) => (
                  <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
                    <TextCard
                      title={item.titre?.length > 25 ? item.titre.substring(0, 25) + "..." : item.titre}
                      reference={item.reference}
                      date={item.dateCloturation || ""}
                      description={
                        item.description?.length > 70
                          ? item.description.substring(0, 70) + "..."
                          : item.description
                      }
                      status={item.statut}
                      onClick={() => navigate(`/offre/${item.idAo}`, { state: item })}
                    />
                  </div>
                ))}
              </div>
            )}
          </main>
        </div>
      </div>
    </div>
  );
};

export default OffrePage;
